/* [VSD Skeleton] - If you need to change this file, it must be changed in the project "skeleton-node-clean-architecture-api" */
export enum IdStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}

export const AllIdStatus = [IdStatus.ACTIVE, IdStatus.INACTIVE];

export type Id = {
  id?: string;
  status?: IdStatus;
  deleted?: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export type OnlyId = Pick<Id, 'id'>;
